"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var CommentServiceTypes_1 = require("../CommentServiceTypes");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var getCopyFromDeletionOutcome = function (deletionOutcome) {
    var _a;
    if (deletionOutcome === CommentServiceTypes_1.CommentSaveOutcome.Success || deletionOutcome === CommentServiceTypes_1.CommentSaveOutcome.None) {
        return "";
    }
    return (_a = {},
        _a[CommentServiceTypes_1.CommentSaveOutcome.CommentDeleted] = "This comment has been recently deleted. Refresh the page and try again.",
        _a[CommentServiceTypes_1.CommentSaveOutcome.ThreadDeleted] = "This thread has been recently deleted. Refresh the page and try again.",
        _a[CommentServiceTypes_1.CommentSaveOutcome.NetworkError] = "Connection issue. Try again?",
        _a[CommentServiceTypes_1.CommentSaveOutcome.LoggedOut] = "You've been logged out. Refresh the page to try again.",
        _a[CommentServiceTypes_1.CommentSaveOutcome.UnknownFailure] = "Send issue. Please try again or refresh the page.",
        _a)[deletionOutcome];
};
var shouldRenderTooltip = function (deletionOutcome) {
    return ![CommentServiceTypes_1.CommentSaveOutcome.Success, CommentServiceTypes_1.CommentSaveOutcome.None].includes(deletionOutcome);
};
var CommentDeleteOverlay = (function (_super) {
    __extends(CommentDeleteOverlay, _super);
    function CommentDeleteOverlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.commentIsDeleting = false;
        _this.deletionOutcome = CommentServiceTypes_1.CommentSaveOutcome.None;
        _this.onConfirmDelete = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.commentIsDeleting = true;
                        this.deletionOutcome = CommentServiceTypes_1.CommentSaveOutcome.None;
                        return [4, this.props.onConfirmDelete()];
                    case 1:
                        result = _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.commentIsDeleting = false;
                            _this.deletionOutcome = result;
                        });
                        return [2];
                }
            });
        }); };
        return _this;
    }
    CommentDeleteOverlay.prototype.render = function () {
        var _a = this.props, onCancelDelete = _a.onCancelDelete, message = _a.message;
        return (react_1.default.createElement("div", { className: "comment-delete-overlay space-inset-m h-center" },
            react_1.default.createElement("div", { className: "comment-delete-overlay__message space-stack-m" }, message),
            react_1.default.createElement("div", { className: "center-aligned" },
                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, className: "space-inline-s", onClick: onCancelDelete }, "Cancel"),
                react_1.default.createElement(kaleidoscope_2.ErrorTooltip, { content: getCopyFromDeletionOutcome(this.deletionOutcome), renderTooltip: this.renderTooltip, size: kaleidoscope_3.TooltipSize.Large },
                    react_1.default.createElement(kaleidoscope_1.Button, { isDestructive: true, type: kaleidoscope_1.ButtonType.Primary, size: kaleidoscope_1.ButtonSize.Small, onClick: this.onConfirmDelete, buttonState: this.commentIsDeleting ? kaleidoscope_1.ButtonState.Waiting : kaleidoscope_1.ButtonState.Idle, disabled: this.commentIsDeleting }, "Delete")))));
    };
    Object.defineProperty(CommentDeleteOverlay.prototype, "renderTooltip", {
        get: function () {
            return !this.commentIsDeleting && shouldRenderTooltip(this.deletionOutcome);
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], CommentDeleteOverlay.prototype, "commentIsDeleting", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof CommentServiceTypes_1.CommentSaveOutcome !== "undefined" && CommentServiceTypes_1.CommentSaveOutcome) === "function" ? _a : Object)
    ], CommentDeleteOverlay.prototype, "deletionOutcome", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], CommentDeleteOverlay.prototype, "renderTooltip", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CommentDeleteOverlay.prototype, "onConfirmDelete", void 0);
    CommentDeleteOverlay = __decorate([
        mobx_react_1.observer
    ], CommentDeleteOverlay);
    return CommentDeleteOverlay;
}(react_1.default.Component));
exports.default = CommentDeleteOverlay;
